<template>
  <div id="admin-container" class="wrapper">
    <div class="inner-wrap">
      <div class="table-filter">
        <input id="admin-search-grapes" type="text" v-model="grapesQuery" v-on:keyup.enter="doGrapeSearch" placeholder="Search grapes" />
        <button id="btnDoSearch" v-on:click="doGrapeSearch()" class="pure-button">Search</button>
        <button id="btnClearSearch" v-on:click="clearSearch()" class="pure-button">Clear</button>
      </div>
      <HotTable :root="root" ref="grapesTable" :settings="hotSettings" :onAfterChange="afterChangeHandler"></HotTable>
    </div>
  </div>
</template>

<script>
  /* global $, algoliasearch */
  import HotTable from 'vue-handsontable-official'
  import firebase from 'firebase'
  import db from '../firebaseInit'

  export default {
    data: function () {
      return {
        root: 'grapes-table',
        userLoggedIn: false,
        userIsAdmin: this.$globals.userRole == 'admin',
        grapes: [],
        grapesQuery: '',
        searchLimit: 200,
        pageLimit: 5000,
        hotSettings: {
          data: this.grapes,
          rowHeaders: true,
          contextMenu: true,
          stretchH: 'all',
          autoWrapRow: true,
          className: 'htCenter htMiddle',
          columnSorting: true,
          sortIndicator: true,
          observeChanges: false,
          colHeaders: ['Doc ID', 'Title', 'Content', 'Notes', 'Length', 'Publish Year', 'Translation', 'Type', 'User ID', 'Username', 'Source', 'Source Author', 'Source Date', 'Source ID', 'Source ISBN', 'Image', 'Amazon URL', 'ID', 'Twitter Count', 'Mailchimp Count', 'Vine Count', 'Rated (-1)', 'Rated (+1)', 'Rated (+2)', 'Total Ratings', 'Average Rating', 'Overall Score', 'Created', 'Updated'],
          rowHeights: 50,
          colWidths: [180, 220, 250, 200, 80, 120, 100, 80, 100, 100, 200, 120, 100, 100, 100, 100, 200, 100, 100, 100, 100, 100, 100, 100, 150, 150, 150, 150, 150],
          columns: [
            {data: 'docID', readOnly: true, type: 'numeric'},
            {data: 'grapeTitle', type: 'text'},
            {data: 'grapeContent', type: 'text'},
            {data: 'grapeNotes', type: 'text'},
            {data: 'grapeLength', type: 'numeric'},
            {data: 'grapeOriginalPublishYear', type: 'numeric'},
            {data: 'grapeTranslation', type: 'text'},
            {data: 'grapeType', type: 'text'},
            {data: 'grapeUserID', type: 'text'},
            {data: 'grapeUsername', type: 'text'},
            {data: 'grapeSource', type: 'text'},
            {data: 'sourceAuthor', type: 'text'},
            {data: 'sourceDate', type: 'text'},
            {data: 'sourceID', type: 'text'},
            {data: 'sourceISBN', type: 'text'},
            {data: 'sourceImage', type: 'text'},
            {data: 'amazonURL', type: 'text'},
            {data: 'id', readOnly: true, type: 'text'},
            {data: 'twitterCampaignCount', type: 'numeric'},
            {data: 'mailchimpCampaignCount', type: 'numeric'},
            {data: 'vinedCount', type: 'numeric'},
            {data: 'rating1', readOnly: true, type: 'numeric'},
            {data: 'rating3', readOnly: true, type: 'numeric'},
            {data: 'rating5', readOnly: true, type: 'numeric'},
            {data: 'totalRating', readOnly: true, type: 'numeric'},
            {data: 'averageRating', readOnly: true, type: 'numeric'},
            {data: 'overallScore', readOnly: true, type: 'numeric'},
            {data: 'createdTimestamp', readOnly: true, type: 'date'},
            {data: 'updatedTimestamp', readOnly: true, type: 'date'}
          ]
        }
      }
    },
    name: 'grapesAdmin',
    components: {
      HotTable
    },
    created () {
      let vm = this
      firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          vm.userLoggedIn = true
        } else {
          vm.userLoggedIn = false
        }
      })
      vm.$globals.isAdmin = true
      vm.showLoading()
      vm.getGrapes()
      /* Set Context Menu */
      vm.hotSettings.contextMenu = {
        callback: function (key, options) {
          if (key === 'about') {
            setTimeout(function () {
              // timeout is used to make sure the menu collapsed before alert is shown
              alert('This is a context menu with default and custom options mixed')
            }, 100)
          }
        },
        items: {
          'hsep2': '---------',
          'about': {name: 'About this menu'}
        }
      }
      /* Set Change Callback */
      vm.hotSettings.afterChange = vm.afterChangeHandler()
    },
    methods: {
      showLoading () {
        $('body').addClass('pace-running')
        $('.pace').addClass('pace-active')
      },
      hideLoading () {
        $('body').removeClass('pace-running')
        $('.pace').removeClass('pace-active')
      },
      afterChangeHandler: function (changes, source) {
        if (arguments[1] !== 'loadData') {
          if (!changes) {
            return
          }
          for (var i = 0, iLen = changes.length; i < iLen; i += 1) {
            if (changes[i][2] !== changes[i][3]) {
              console.log('trying to change')
              let logicalIndex = this.$refs.grapesTable.table.runHooks('modifyRow', changes[i][0])
              let changedDocID = this.$refs.grapesTable.table.getDataAtCell(changes[i][0], 0)
              let newData = this.$refs.grapesTable.table.getSourceDataAtRow(logicalIndex)
              delete newData._highlightResult
              delete newData.objectID
              delete newData.docID
              console.log(changedDocID)
              console.log(newData)
              if (changedDocID) {
                this.processChange(changedDocID, newData)
              }
            }
          }
        }
      },
      getGrapes: function () {
        let vm = this
        let regex = /\s+/gi
        let rating1Weight = -1
        let rating3Weight = 1
        let rating5Weight = 2
        var grapesRef = db.collection('grapes').limit(vm.pageLimit)
        grapesRef.get().then((querySnapshot) => {
          console.log('created query: ' + querySnapshot.docs.length)
          querySnapshot.forEach((doc) => {
            var grapeData = doc.data()
            grapeData.docID = doc.id
            grapeData.grapeLength = grapeData.grapeContent.trim().replace(regex, ' ').split(' ').length
            grapeData.vinedCount = grapeData.vinedCount ? parseInt(grapeData.vinedCount) : 0
            grapeData.rating1 = grapeData.rating1 ? parseInt(grapeData.rating1) : 0
            grapeData.rating3 = grapeData.rating3 ? parseInt(grapeData.rating3) : 0
            grapeData.rating5 = grapeData.rating5 ? parseInt(grapeData.rating5) : 0
            grapeData.totalRating = grapeData.rating1 + grapeData.rating3 + grapeData.rating5
            grapeData.averageRating = Math.floor(((rating1Weight * grapeData.rating1) + (rating3Weight * grapeData.rating3)  + (rating5Weight * grapeData.rating5)) / grapeData.totalRating)
            grapeData.overallScore = grapeData.averageRating + grapeData.vinedCount
            this.grapes.push(grapeData)
          })
          /* Load Data */
          vm.$refs.grapesTable.table.loadData(vm.grapes)
          setTimeout(function () {
            vm.hideLoading()
          }, 1000)
        })
      },
      doGrapeSearch () {
        let vm = this
        vm.grapes = []
        var client = algoliasearch('BLP5M7YD97', 'e43146fabb439a15a2622c0264710cb6')
        var index = client.initIndex('grapes')
        var query = vm.grapesQuery
        index.search({
          query: query,
          hitsPerPage: vm.searchLimit
        }).then(responses => {
          // Response from Algolia:
          // https://www.algolia.com/doc/api-reference/api-methods/search/#response-format
          var results = responses.hits
          console.log('number of results: ' + results.length)
          for (var i = 0; i < results.length; i++) {
            var obj = results[i]
            if (!obj.docID) {
              obj.docID = obj.objectID
            }
            vm.grapes.push(obj)
          }
          /* Load Data */
          vm.$refs.grapesTable.table.loadData(vm.grapes)
        })
      },
      clearSearch () {
        let vm = this
        vm.grapes = []
        vm.getGrapes()
      },
      processChange (docID, newData) {
        console.log('trying to update grape')
        let vm = this
        var grapeRef = db.collection('grapes').doc(docID)
        const timestamp = firebase.firestore.FieldValue.serverTimestamp()
        delete newData.createdTimestamp
        delete newData.vinedCount
        delete newData.rating1
        delete newData.rating3
        delete newData.rating5
        delete newData.totalRatings
        delete newData.averageRating
        delete newData.overallScore
        delete newData._highlightResult
        newData.updatedTimestamp = timestamp
        grapeRef.update(newData)
        .then(function (docRef) {
          console.log('Document ' + docID + ' successfully updated!')
          newData.docID = docID
          mixpanel.track(
            'Grape updated through Admin Panel',
            {
              'docID': docID
            }
          )
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
      }
    }
  };
</script>

<style>
  .table-filter {
    padding: 10px 0;
  }
  .table-filter input {
    height: 40px;
    width: 300px;
    padding: 4px 10px;
    box-sizing: border-box;
  }
  .table-filter .pure-button {
    vertical-align: top;
  }
  #grapes-table {
    width: 100%;
    height: 100vh;
    height: calc(100vh - 120px);
    margin-top: 4px;
    overflow: hidden;
  }
  #grapes-table th {
    vertical-align: middle;
  }
  #grapes-table td {
    max-width: 320px;
    min-width: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap !important;
    padding: 0 10px;
  }
  #grapes-table thead th .relative {
    padding: 4px 8px;
  }
</style>


// WEBPACK FOOTER //
// src/components/admin/grapesAdmin.vue